import apiPaths from '../api-paths';

export default {
  createAuthorization({ jwt, target }) {
    return axios.post(`${ apiPaths.API }/api/authorizations`, {
      jwt,
      target
    });
  },
}; 